import React from 'react';

const ContentManager = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white shadow rounded-lg p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Content Manager</h1>
        <p className="text-gray-600">Content management interface coming soon...</p>
      </div>
    </div>
  );
};

export default ContentManager;
